// Centralized site configuration (replace placeholders before deploying)
export const WHATSAPP_NUMBER = "5521975203353";
export const WHATSAPP_MESSAGE = encodeURIComponent(
  "Olá, Dra. Luz Adriana! Gostaria de agendar uma avaliação para tratamento com Toxina Botulínica."
);
export const whatsappLink = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export const CONTACT = {
  fullName: "Dra. Luz Adriana",
  phoneDisplay: "+55 (21) 97520-3353",
  instagramHandle: "@draluzadriana",
  instagramUrl: "https://instagram.com/draluzadriana",
};

export const ADDRESSES = [
  {
    label: "Rio de Janeiro — Jardim Botânico 660",
    line: "Rua Jardim Botânico, 660",
    city: "Rio de Janeiro — RJ, Brasil",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Rua+Jardim+Bot%C3%A2nico+660+Rio+de+Janeiro",
  },
  {
    label: "Rio de Janeiro — Jardim Botânico 568",
    line: "Rua Jardim Botânico, 568",
    city: "Rio de Janeiro — RJ, Brasil",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Rua+Jardim+Bot%C3%A2nico+568+Rio+de+Janeiro",
  },
  {
    label: "Niterói — Icaraí",
    line: "Rua Gavião Peixoto, 124 — Sala 501",
    city: "Icaraí, Niterói — RJ, 24230-101",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Rua+Gavi%C3%A3o+Peixoto+124+Icara%C3%AD+Niter%C3%B3i",
  },
];

export const LOGO_IMG =
  "https://customer-assets.emergentagent.com/job_consulta-enxaqueca/artifacts/n2ebs76l_Captura%20de%20tela%202026-06-24%20132418.png";

export const DOCTOR_IMG =
  "https://s3-sa-east-1.amazonaws.com/doctoralia.com.br/doctor/a6fb17/a6fb17d286bb99bdef7ded66ac6c7742_large.jpg"
export const HERO_IMG =
  "https://s3-sa-east-1.amazonaws.com/doctoralia.com.br/doctor/a6fb17/a6fb17d286bb99bdef7ded66ac6c7742_large.jpg"
export const CLINIC_IMG =
  "https://images.unsplash.com/photo-1742367539759-6e4fc2e39209?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtZWRpY2FsJTIwY2xpbmljJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgxMDUzMDQzfDA&ixlib=rb-4.1.0&q=85";

export const RELIEF_IMG =
  "https://images.unsplash.com/photo-1686485237014-99a50b9936ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHJlbGF4aW5nJTIwaGVhZGFjaGUlMjByZWxpZWZ8ZW58MHx8fHwxNzgxMDUzMDQzfDA&ixlib=rb-4.1.0&q=85";
